import { type FC, type ReactNode } from "react";
import { PackageRestrictionContext } from "~/common/components/PackageRestrictionContext/PackageRestrictionContext";
import { useCalculateRestrictedCode } from "~/common/components/PackageRestrictionContext/useCalculateRestrictedCode";

interface Props {
  productCode: string;
  children?: ReactNode;
}
export const AutosuggestPackageRestrictionContext: FC<Props & { query: string }> = ({
  productCode,
  query,
  children,
}) => {
  const restrictedCode = query.length === 2 ? query : useCalculateRestrictedCode(query, productCode);

  return <PackageRestrictionContext value={restrictedCode}>{children}</PackageRestrictionContext>;
};
